import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const useStore = create(
  persist(
    (set, get) => ({
      // 用户信息
      user: null,
      setUser: (user) => set({ user }),
      
      // 测评数据
      assessmentData: null,
      setAssessmentData: (data) => set({ assessmentData: data }),
      
      // 匹配结果
      matchResult: null,
      setMatchResult: (result) => set({ matchResult: result }),
      
      // 精准报告
      precisionReport: null,
      setPrecisionReport: (report) => set({ precisionReport: report }),
      
      // 订单信息
      currentOrder: null,
      setCurrentOrder: (order) => set({ currentOrder: order }),
      
      // 已购套餐
      purchasedPackages: [],
      setPurchasedPackages: (packages) => set({ purchasedPackages: packages }),
      addPurchasedPackage: (pkg) => set((state) => ({
        purchasedPackages: [...state.purchasedPackages, pkg]
      })),
      
      // 页面状态
      currentPage: 1,
      setCurrentPage: (page) => set({ currentPage: page }),
      
      // 加载状态
      isLoading: false,
      setIsLoading: (loading) => set({ isLoading: loading }),
      
      // 错误信息
      error: null,
      setError: (error) => set({ error }),
      clearError: () => set({ error: null }),
      
      // 隐私协议同意状态
      privacyAgreed: false,
      setPrivacyAgreed: (agreed) => set({ privacyAgreed: agreed }),
      
      // 分享人追踪
      referrerCode: null,
      setReferrerCode: (code) => set({ referrerCode: code }),
      
      // 重置所有状态
      reset: () => set({
        user: null,
        assessmentData: null,
        matchResult: null,
        precisionReport: null,
        currentOrder: null,
        currentPage: 1,
        isLoading: false,
        error: null,
        privacyAgreed: false
      })
    }),
    {
      name: 'grad-job-storage',
      partialize: (state) => ({
        user: state.user,
        assessmentData: state.assessmentData,
        matchResult: state.matchResult,
        precisionReport: state.precisionReport,
        purchasedPackages: state.purchasedPackages,
        privacyAgreed: state.privacyAgreed,
        referrerCode: state.referrerCode
      })
    }
  )
)

export default useStore
